import PropTypes from 'prop-types';
import React from 'react';
import { Common } from 'ws-scripts/modules/common';
import { ModalDock } from './ModalDock';

import DisclaimerContent from './DisclaimerContent.jsx';

import { MODAL, DOCK, LEASE } from '../constants/constants';
import { getDisclaimerPlaceholderObj } from '../utils/utility';
import {
	FINANCE_DRIVER_FINANCE_PAYMENT_TOOLTIP_VERBIAGE,
	FINANCE_DRIVER_LEASE_PAYMENT_TOOLTIP_VERBIAGE,
	EST_LEASE_DISCLAIMER_HEADING,
	EST_FINANCE_DISCLAIMER_HEADING
} from '../constants/labels';

class PricingLoanLease extends React.Component {
	constructor() {
		super();
		this.state = {
			showDisclaimer: false,
			disclaimerTitle: <span />,
			disclaimerContent: <span />
		};

		this.renderLayout = this.renderLayout.bind(this);
		this.getModalDockOptions = this.getModalDockOptions.bind(this);
		this.toggleDisclaimer = this.toggleDisclaimer.bind(this);
		this.renderList = this.renderList.bind(this);
	}

	getModalDockOptions(isMobile) {
		const {
			showDisclaimer,
			disclaimerTitle,
			disclaimerContent
		} = this.state;

		return {
			display: isMobile ? DOCK : MODAL,
			showState: showDisclaimer,
			closeMethod: this.toggleDisclaimer,
			title: disclaimerTitle,
			body: disclaimerContent
		};
	}

	toggleDisclaimer(disclaimerTitle = <span />, disclaimerContent = <span />) {
		this.setState({
			showDisclaimer: !this.state.showDisclaimer,
			disclaimerTitle,
			disclaimerContent
		});
	}

	renderList(item, index, listSize, labels) {
		const { toggleDisclaimer } = this;
		const { _type, label, formatted, dealershipName } = item;
		const isLeasePayment = _type === LEASE;
		const SECOND_ITEM = 2;

		const disclaimer = isLeasePayment
			? FINANCE_DRIVER_LEASE_PAYMENT_TOOLTIP_VERBIAGE
			: FINANCE_DRIVER_FINANCE_PAYMENT_TOOLTIP_VERBIAGE;
		const disclaimerPlaceholder = getDisclaimerPlaceholderObj(item);

		const disclaimerTitle = isLeasePayment
			? EST_LEASE_DISCLAIMER_HEADING
			: EST_FINANCE_DISCLAIMER_HEADING;

		const listPosition = listSize === SECOND_ITEM ? 'two-item' : 'one-item';
		const border = index === SECOND_ITEM ? 'border-left' : null;
		const listClass = [listPosition, border];

		const DynamicDisclaimerContent = (
			<DisclaimerContent
				placeholderValuesObj={disclaimerPlaceholder}
				disclaimerLabel={disclaimer}
				dealershipName={dealershipName}
			/>
		);

		const iconHtml = (
			<i className="ddc-icon ddc-icon-help-circle text-muted ddc-icon-size-small d-inline-block pl-1" />
		);

		const labelHtml = (
			<span className="text-muted d-block text-nowrap">
				{labels.get(label)}
				<button
					className="btn-link p-0"
					onClick={() =>
						toggleDisclaimer(
							labels.get(disclaimerTitle),
							DynamicDisclaimerContent
						)
					}
				>
					{iconHtml}
				</button>
			</span>
		);

		const priceHtml = (
			<strong className="line-height-reset font-weight-bold ddc-font-size-large">
				{formatted}
			</strong>
		);

		const termHtml = (
			<span className="ddc-font-size-small text-muted">
				{labels.get('SLASH_MO')}
			</span>
		);

		return (
			<li
				className={`${listClass.filter(Boolean).join(' ')}`}
				key={`${label}`}
			>
				{labelHtml}
				<span>
					{priceHtml}
					{termHtml}
				</span>
			</li>
		);
	}

	renderLayout({ labels, prefs }) {
		const { summary } = this.props;
		const { renderList } = this;
		const { paymentBoxPadding, paymentBoxBackground } = prefs;

		const layoutClasses = 'pricing-loan-lease list-unstyled d-flex mb-0';
		const paddingClasses = `px-${paymentBoxPadding} py-${paymentBoxPadding}`;
		const componentClasses = [
			layoutClasses,
			paddingClasses,
			paymentBoxBackground
		];

		return (
			<ul className={componentClasses.join(' ')}>
				{summary.map((item, index) => {
					return renderList(item, index + 1, summary.length, labels);
				})}
			</ul>
		);
	}

	render() {
		const { isMobile, isScrollingSidebar } = this.props;
		const { getModalDockOptions } = this;

		let renderLoanLease = null;
		if (!isScrollingSidebar) {
			/* props for the ModalDock component */
			const options = getModalDockOptions(isMobile);

			renderLoanLease = (
				<React.Fragment>
					<Common render={this.renderLayout} />
					<ModalDock {...options} />
				</React.Fragment>
			);
		}
		return renderLoanLease;
	}
}

PricingLoanLease.propTypes = {
	isMobile: PropTypes.bool.isRequired,
	summary: PropTypes.arrayOf(
		PropTypes.shape({
			_type: PropTypes.string.isRequired,
			formatted: PropTypes.string.isRequired,
			key: PropTypes.string,
			label: PropTypes.string.isRequired,
			value: PropTypes.number.isRequired
		})
	).isRequired,
	isScrollingSidebar: PropTypes.bool.isRequired
};

export default PricingLoanLease;



// WEBPACK FOOTER //
// ./src/components/PricingLoanLease.jsx